<template>
  <el-container>
    <el-header>
      <img src="@/assets/mai-logo.png" alt="mai-assignment" />
    </el-header>
    <el-container>
      <el-aside width="400px">
        <mai-profile :participants="participants" :case-info="caseInfo" :user-info="userInfo"/>
      </el-aside>
      <el-main>
        <mai-chat :participants="participants" :case-info="caseInfo" :user-info="userInfo"/>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import MaiChat from './MaiChat'
import MaiProfile from './MaiProfile'
export default {
  name: 'ChatWindow',
  data () {
    return {
      stompClient: null,
      participants: [],
      caseInfo: {
        id: '', name: '', type: '', assignment: '', location: ''
      },
      userInfo: {
        id: '', fullname: ''
      }
    }
  },
  components: {
    MaiChat,
    MaiProfile
  }
}
</script>
<style lang="scss">
#mai-chat {
  .chat-search {
    background: transparent;
    color: #e5e5e5;
    border: none;
    outline: none;
    border-bottom: 2px solid #e5e5e5;
    width: 100%;
    &::placeholder {
      color: #e5e5e5;
    }
  }
  z-index: 10000;
  width: 500px;
  footer {
    background: #045B89;
    padding: 10px;
    color: #fff;
  }
  header {
    padding: 10px;
    color: #fff;
    display: flex;
    justify-content: space-between;
  }
  main {
    max-height: 0;
    transition: max-height 0.3s;
    overflow: hidden;
    background: #e5e5e5;
    &.active {
      height: 420px;
      max-height: 420px;
      overflow: auto;
    }
  }
}
#mai-profile {
  z-index: 10000;
  width: 500px;
  footer {
    background: #045B89;
    padding: 10px;
    color: #fff;
  }
  header {
    background: #0f92da;
    padding: 10px;
    color: #fff;
    width: 100%;
  }
  main {
    max-height: 0;
    transition: max-height 0.3s;
    overflow: hidden;
    background: #e5e5e5;
    &.active {
      height: 420px;
      max-height: 420px;
      overflow: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/sections/chat/ChatWindow.vue